
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ASIA__',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ASIA__.vue